module.exports = __webpack_public_path__ + "media/images/case-det-74fa6061.jpg";